import { useContext } from 'react';
import { UserViewerContext } from '../context/userViewerContext';

const useUserViewer = () => {
  return useContext(UserViewerContext);
};

export default useUserViewer;
